import React, {useContext, useEffect, useState,} from 'react';
import {useParams, useNavigate, useLocation, useSearchParams} from 'react-router-dom';

import {useHttpClient} from '../../../../common/hook/http';
import Loader from '../../../../common/component/Loader/Loader';

import Steps from '../../../../common/component/Steps/Steps'

import GlobalConst from '../../../../common/global-const';

import Form from './Form'

import {Container, Row, Col} from 'react-bootstrap';

import './TicketOrder.scss';
import NoContent from "../../../../common/component/NoContent/NoContent";

const EntertainTicketOrder = () => {
    const {callAPI} = useHttpClient()
    const navigate = useNavigate()
    const params = useParams();
    const location = useLocation();

    const payFromAccount = location.state?.entertainmentPlace ? {
        entertainmentPlace: location.state.entertainmentPlace,
        types: [{value: location.state.entertainmentPlace.type, label: location.state.entertainmentPlace.typeTitle, price: location.state.entertainmentPlace.price}],
        arrayTime: {[location.state.entertainmentPlace.reserve_date]: [{start_time: location.state.entertainmentPlace.reserve_time, end_time: location.state.entertainmentPlace.endTime}]},
        tax: location.state.tax
    } : null

    const [data, setData] = useState(payFromAccount ? payFromAccount : null)

    // ----------------------------------------------------------------------------------------------------------- steps

    const [searchParams, setSearchParams] = useSearchParams();

    const stepsTotal = 3;
    const [step, setStep] = useState(payFromAccount ? Number(searchParams.get('step')) : params.id ? 2 : 1);

    useEffect(() => {

        let stepTemp = Number(searchParams.get('step'))

        // بین step با مقدار 1 و 2 خالی می شود تا مقدار جدید دریافت شود
        if (data && stepTemp < 3) setData(null)

        if (params.id) {

            switch(stepTemp) {
                case 1:
                    setSearchParams({step: 2})
                    if (step !== 2) setStep(2)
                    break
                case 2:
                    if (step !== stepTemp) setStep(stepTemp)
                    break
                case 3:
                    if (data) setStep(stepTemp)
                    else setSearchParams({step: 2})
                    break
                default:
                    // جهت جلوگیری از ایجاد یک history بدون step از replace استفاده شد
                    setSearchParams({step: 2}, {replace: true})
                    if (step !== 2) setStep(2)
            }

        } else {

            if (location.pathname.includes('?')) {
                let pathnameTemp = location.pathname.split(`?`)[0]
                navigate(pathnameTemp)
            }

            if (step !== 1) setStep(1)

        }

    }, [searchParams.get('step')])

    // ------------------------------------------------------------------------------------------------------ fetch data

    useEffect(() => {

        if (params.id) {

            document.documentElement.dataset.page = 'entertain-ticket-order';
            document.querySelector('#header .navbar-brand').innerHTML = 'خرید آنلاین بلیط'

        }

        const fetchData = async () => {

            try {
                const responseData = await callAPI(
                    params.id ? `entertainment/reservation/${params.id}` : `entertainment`
                );

                // console.log(responseData)

                if (responseData.message) {

                } else {

                    setData(params.id ? responseData.result : responseData.result.entertainments)

                }

            } catch (e) {
                console.error(e);
            }
        }

        if ((step === 1 && !params.id) || (step === 2 && params.id)) fetchData()

    }, [step])

    // -----------------------------------------------------------------------------------------------------------------

    const stepChangeHandler = event => {

        window.scrollTo(0, 0)

        if (event.type === 'submit') setSearchParams({step: step + 1})
        else if (event.type === 'click') {

            if (step === 2) navigate(location.pathname.split(`/${params.id}`)[0])
            else setSearchParams({step: step - 1})

        }

    };

    // -----------------------------------------------------------------------------------------------------------------
// console.log(data)
    return (
        <div id="pageEntertainTicketOrder" className="has-page-footer">
            {
                data ? (
                    <>
                        {
                            (step === 1 && data.length) || step !== 1 ? (
                                <Container fluid="lg" className="steps">
                                    <Steps stepsTotal={stepsTotal} step={step}/>
                                </Container>
                            ) : (
                                <></>
                            )
                        }
                        <Container fluid="lg">
                            {
                                step === 1 ? (
                                    data.length ? (
                                        <Row className="g-3">
                                            <Col xs={12}>
                                                <p>کاربر گرامی، مکان تفریحی مورد نظر را انتخاب نمایید:</p>
                                            </Col>
                                            {
                                                data.map(item => {
                                                    return (
                                                        <Col xs={6} sm={4} md={3} lg={2} key={item.id}>
                                                            <div className="fs-5" role="button" onClick={() => navigate(`${location.pathname}/${item.id}?step=2`)}>
                                                                <figure className="mb-2 ratio ratio-1x1 filter-warm">
                                                                    <span className="filter-level"/>
                                                                    <img src={`${GlobalConst.cdn}${item.photos[0].path}`} className="w-100 h-100 object-fit-cover"/>
                                                                </figure>
                                                                {item.name}
                                                            </div>
                                                        </Col>
                                                    )
                                                })
                                            }
                                        </Row>
                                    ) : (
                                        <div className="py-5 my-5">
                                            <NoContent text={`اطلاعات وجود ندارد`}/>
                                        </div>
                                    )
                                ) : (
                                    <Form onStepChange={stepChangeHandler} step={step} item={data}/>
                                )
                            }
                        </Container>
                    </>
                ) : (
                    <div className="py-5 my-5">
                        <Loader text="در حال دریافت اطلاعات"/>
                    </div>
                )
            }
        </div>
    )
}

export default EntertainTicketOrder;